import { executeWithObject } from 'utils/fp';

import breakpoints from './breakpoints';

const transformToNumbers = executeWithObject.values((v: string) => +v.slice(0, v.indexOf('px')));

const numbers = transformToNumbers<typeof breakpoints, number>(breakpoints);

const deviceSizes = {
  numbers,
  texts: breakpoints,
};

export default deviceSizes;
